import React, { useEffect, useState } from "react";
import { API } from "../../config/api";
import "./../Styles/profile.css";

export default function CreateSupplierType() {
  const [type, setType] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [supplierTypes, setSupplierTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);

  const fetchSupplierTypes = async () => {
    try {
      const res = await fetch(`${API.BASE_URL}/api.php?action=supplier_types`);
      const data = await res.json();

      if (data.status) {
        setSupplierTypes(data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchSupplierTypes();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const form = new FormData();
    form.append("type", type.toLowerCase().trim());
    form.append("display_name", displayName);

    let action = "create_supplier_type";

    if (editId) {
      action = "update_supplier_type";
      form.append("id", editId);
    }

    try {
      const res = await fetch(`${API.BASE_URL}/api.php?action=${action}`, {
        method: "POST",
        body: form,
      });

      const text = await res.text();

      const data = JSON.parse(text);

      alert(data.message);

      if (data.status) {
        setType("");
        setDisplayName("");
        setEditId(null);
        fetchSupplierTypes();
        window.dispatchEvent(new Event("refreshSupplierTypes"));
      }
    } catch (err) {
      console.error(err);
      alert(err.message);
    }

    setLoading(false);
  };

  const handleEdit = (item) => {
    setEditId(item.id);
    setType(item.type);
    setDisplayName(item.display_name);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this supplier type?")) return;

    const form = new FormData();
    form.append("id", id);

    try {
      const res = await fetch(
        `${API.BASE_URL}/api.php?action=delete_supplier_type`,
        {
          method: "POST",
          body: form,
        },
      );

      const data = await res.json();

      alert(data.message);

      if (data.status) {
        fetchSupplierTypes();
        window.dispatchEvent(new Event("refreshSupplierTypes"));
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="st-page">
      <div className="st-header">
        <h2>Supplier Type Management</h2>
        <p>Create and manage supplier categories.</p>
      </div>

      <div className="row g-4">
        {/* Left */}
        <div className="col-lg-12">
          <div className="st-card">
            <div className="st-card-title">
              {editId ? "Update Supplier Type" : "New Supplier Type"}
            </div>

            <form onSubmit={handleSubmit} className="st-horizontal-form">
              <div className="st-form-group">
                <label>Type</label>
                <input
                  className="form-control st-input"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  placeholder="fabric"
                  required
                />
              </div>

              <div className="st-form-group">
                <label>Display Name</label>
                <input
                  className="form-control st-input"
                  value={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}
                  placeholder="Fabric"
                  required
                />
              </div>

              <div className="st-form-actions">
                <button className="btn st-btn-primary" disabled={loading}>
                  {loading ? "Saving..." : editId ? "Update" : "Create"}
                </button>

                {editId && (
                  <button
                    type="button"
                    className="btn st-btn-light"
                    onClick={() => {
                      setEditId(null);
                      setType("");
                      setDisplayName("");
                    }}
                  >
                    Cancel
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>

        {/* Right */}

        <div className="col-lg-12">
          <div className="st-card">
            <div className="st-card-header">
              <div>
                <h5>Table Name</h5>

                <span>{supplierTypes.length} Records</span>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table st-table align-middle">
                <thead>
                  <tr className="text-center">
                    <th width="80">ID</th>

                    <th>Type</th>

                    <th>Display Name</th>

                    <th width="170">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {supplierTypes.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center py-5">
                        No Supplier Types Found
                      </td>
                    </tr>
                  ) : (
                    supplierTypes.map((item) => (
                      <tr key={item.id}>
                        <td>{item.id}</td>

                        <td>
                          <span className="st-badge">{item.type}</span>
                        </td>

                        <td>{item.display_name}</td>

                        <td style={{ display: "flex" }}>
                          <button
                            className="btn st-edit-btn"
                            onClick={() => handleEdit(item)}
                            title="Edit"
                          >
                            <i className="bi bi-pencil-square"></i>
                          </button>

                          <button
                            className="btn st-delete-btn ms-2"
                            onClick={() => handleDelete(item.id)}
                            title="Delete"
                          >
                            <i className="bi bi-trash3"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
